// Single source of truth for "is audio muted", shared by the music
// controller and the SFX controller (audio.js / sfx.js) so the one mute
// button silences everything instead of just the backing track.
const MUTE_STORAGE_KEY = "wheres-bliss-music-muted";

let muted = localStorage.getItem(MUTE_STORAGE_KEY) === "1";
const listeners = new Set();

export function isMuted() {
  return muted;
}

export function setMuted(next) {
  muted = next;
  localStorage.setItem(MUTE_STORAGE_KEY, muted ? "1" : "0");
  listeners.forEach((fn) => fn(muted));
}

/** Returns an unsubscribe function. */
export function onMuteChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
